import { FunctionComponent } from "react";
import { IonButton, IonFooter, IonIcon, IonLoading, IonToolbar } from "@ionic/react";
import "./site-page-footer.component.scss";

interface SitePageFooterComponentProps {
  onClick: () => void;
  footerLabel: string;
  synchronizingLabel?: string;
  icon: string;
  color: string;
  isLoading?: boolean;
}

export const SitePageFooterComponent: FunctionComponent<SitePageFooterComponentProps> = (props) => (
  <IonFooter className="ion-no-border site-page-footer">
    <IonToolbar>
      <IonButton
        role="button"
        aria-label={props.footerLabel}
        color={props.color}
        expand="block"
        className="ion-padding-horizontal"
        onClick={props.onClick}
      >
        {props.isLoading ? (
          <IonLoading isOpen={true} message={props.synchronizingLabel} />
        ) : (
          <>
            <IonIcon slot="start" icon={props.icon} />
            {props.footerLabel}
          </>
        )}
      </IonButton>
    </IonToolbar>
  </IonFooter>
);
